// The words to show when a request fails: the server's own message ({detail}), or the problems it
// listed per field ({field: ["..."]}), else the fallback. Never the bare status line, never an
// object (React cannot draw one).
export function errorText(error, fallback = "That did not work. Please try again.") {
  const payload = error?.payload;
  if (typeof payload?.detail === "string" && payload.detail) return payload.detail;
  if (payload && typeof payload === "object") {
    const lines = Object.values(payload).flat().filter((item) => typeof item === "string" && item);
    if (lines.length) return lines.join(" ");
  }
  return fallback;
}
